<section class="flex flex-col gap-2">
  <div class="flex flex-wrap items-center justify-between gap-2">
    <div>
      <h3 class="text-base leading-5 font-medium text-gray-900">
        Pending Tasks
      </h3>
      <p class="text-xs text-gray-500">
        Referral acceptance and invoice creation items
      </p>
    </div>

    <div class="inline-flex rounded-md border border-gray-200 bg-white p-0.5">
      @for (tab of tabs; track tab.kind) {
        <button
          type="button"
          class="rounded px-2 py-1 text-xs font-medium transition-colors"
          [class.bg-orange-100]="selectedKind() === tab.kind"
          [class.text-orange-800]="selectedKind() === tab.kind"
          [class.text-gray-600]="selectedKind() !== tab.kind"
          [class.hover:bg-gray-50]="selectedKind() !== tab.kind"
          (click)="selectedKind.set(tab.kind)"
        >
          {{ tab.label }} ({{ countFor(tab.kind) }})
        </button>
      }
    </div>
  </div>

  @if (error()) {
    <lib-error-alert [error]="error()" />
  } @else {
    <div class="rounded-md border border-gray-200 bg-white">
      @if (loading()) {
        <div class="space-y-2 p-3">
          @for (item of loadingRows; track item) {
            <div class="h-11 animate-pulse rounded bg-gray-100"></div>
          }
        </div>
      } @else if (selectedTasks().length) {
        <div
          class="grid max-h-[22rem] grid-cols-1 gap-3 overflow-y-auto overscroll-contain p-3 md:grid-cols-2 xl:grid-cols-3"
        >
          @for (task of selectedTasks(); track taskKey(task)) {
            @if (isCommissionTask(task)) {
              <lib-pending-commission-task-card [task]="task" />
            } @else {
              <lib-pending-referral-task-card [task]="task" />
            }
          }
        </div>
      } @else {
        <div class="p-4 text-sm text-gray-500">
          {{ selectedTab().emptyTitle }}
        </div>
      }
    </div>
  }
</section>
